import { KYMW4100Component } from './kymw4100.component';

/**
 * 統一企画点検リスト画面の値を管理するクラス
 *
 * @export KYMW4100Model
 * @class KYMW4100Model
 */
export class KYMW4100Model {

  public kymw4100Component: KYMW4100Component;

  public promotionList = [];
  public fileUrl: string = null;

  public totalNum: number = null;

  // 画面バインド用変数
  public orderCode: string = <string>'';
  public medium: string = <string>'';
  public startPageNum: string = <string>'';
  public endPageNum: string = <string>'';
  public radioGroup: string = <string>'';
  public mediumTo: string = <string>'';

  public allCoop: boolean = null;
  public ibaraki: boolean = null;
  public tochigi: boolean = null;
  public gunma: boolean = null;
  public chiba: boolean = null;
  public saitama: boolean = null;
  public tokyo: boolean = null;
  public nagano: boolean = null;
  public niigata: boolean = null;
  public kuruco: boolean = null;

  // 活性非活性判定用変数
  public enabledMediumToFlg = false;

  /**
   * 統一企画点検リスト出力処理レスポンス取得
   */
  public updateFileUrl(data: any) {
    // レスポンスの内容からFilenameを取得
    this.fileUrl = data.FileName;
  }
}
